export default {
  navigationBarTitleText: '更火新用户专享优惠'
};
